exports.data =
    JSON.parse(`{
        "results": [
            {
                "id": 1,
                "name": "Egypt",
                "code": "EG",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 2,
                "name": "South Sudan",
                "code": "SS",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 3,
                "name": "Seychelles",
                "code": "SC",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 4,
                "name": "Swaziland",
                "code": "SZ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 5,
                "name": "El Salvador",
                "code": "SV",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 6,
                "name": "Christmas Island",
                "code": "CX",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 7,
                "name": "Australia",
                "code": "AU",
                "currency_id": 5,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 8,
                "name": "Andorra",
                "code": "AD",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 9,
                "name": "Puerto Rico",
                "code": "PR",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 10,
                "name": "Denmark",
                "code": "DK",
                "currency_id": 13,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 11,
                "name": "Barbados",
                "code": "BB",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 12,
                "name": "Slovakia",
                "code": "SK",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 13,
                "name": "Saint Lucia",
                "code": "LC",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 14,
                "name": "Serbia",
                "code": "RS",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 15,
                "name": "Israel",
                "code": "IL",
                "currency_id": 34,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 16,
                "name": "United Kingdom",
                "code": "GB",
                "currency_id": 3,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 17,
                "name": "Norway",
                "code": "NO",
                "currency_id": 10,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 18,
                "name": "Turkmenistan",
                "code": "TM",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 19,
                "name": "Brazil",
                "code": "BR",
                "currency_id": 6,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 20,
                "name": "Norfolk Island",
                "code": "NF",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 21,
                "name": "Bangladesh",
                "code": "BD",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 22,
                "name": "Uganda",
                "code": "UG",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 23,
                "name": "Kuwait",
                "code": "KW",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 24,
                "name": "Gabon",
                "code": "GA",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 25,
                "name": "Montserrat",
                "code": "MS",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 26,
                "name": "Angola",
                "code": "AO",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 27,
                "name": "Nigeria",
                "code": "NG",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 28,
                "name": "Mozambique",
                "code": "MZ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 29,
                "name": "Martinique",
                "code": "MQ",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 30,
                "name": "Saint Pierre and Miquelon",
                "code": "PM",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 31,
                "name": "Chad",
                "code": "TD",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 32,
                "name": "Belarus",
                "code": "BY",
                "currency_id": 7,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 33,
                "name": "Gambia",
                "code": "GM",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 34,
                "name": "South Georgia and the South Sandwich Islands",
                "code": "GS",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 35,
                "name": "Monaco",
                "code": "MC",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 36,
                "name": "Georgia",
                "code": "GE",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 37,
                "name": "Japan",
                "code": "JP",
                "currency_id": 14,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 38,
                "name": "Cook Islands",
                "code": "CK",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 39,
                "name": "Guinea",
                "code": "GN",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 40,
                "name": "Equatorial Guinea",
                "code": "GQ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 41,
                "name": "Switzerland",
                "code": "CH",
                "currency_id": 33,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 42,
                "name": "Niue",
                "code": "NU",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 43,
                "name": "Niger",
                "code": "NE",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 44,
                "name": "Bahamas",
                "code": "BS",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 45,
                "name": "Uzbekistan",
                "code": "UZ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 46,
                "name": "Sao Tome and Principe",
                "code": "ST",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 47,
                "name": "Kyrgyzstan",
                "code": "KG",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 48,
                "name": "French Polynesia",
                "code": "PF",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 49,
                "name": "Panama",
                "code": "PA",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 50,
                "name": "Lebanon",
                "code": "LB",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 51,
                "name": "Dominica",
                "code": "DM",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 52,
                "name": "Brunei Darussalam",
                "code": "BN",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 53,
                "name": "Liechtenstein",
                "code": "LI",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 54,
                "name": "Guernsey",
                "code": "GG",
                "currency_id": 3,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 55,
                "name": "Fiji",
                "code": "FJ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 56,
                "name": "Guyana",
                "code": "GY",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 57,
                "name": "Thailand",
                "code": "TH",
                "currency_id": 31,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 58,
                "name": "Russian Federation",
                "code": "RU",
                "currency_id": 7,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 59,
                "name": "Yemen",
                "code": "YE",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 60,
                "name": "Marshall Islands",
                "code": "MH",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 61,
                "name": "Turks and Caicos Islands",
                "code": "TC",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 62,
                "name": "Qatar",
                "code": "QA",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 63,
                "name": "France",
                "code": "FR",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 64,
                "name": "Zambia",
                "code": "ZM",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 65,
                "name": "Slovenia",
                "code": "SI",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 66,
                "name": "Germany",
                "code": "DE",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 67,
                "name": "Malaysia",
                "code": "MY",
                "currency_id": 30,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 68,
                "name": "Togo",
                "code": "TG",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 69,
                "name": "Malawi",
                "code": "MW",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 70,
                "name": "Lithuania",
                "code": "LT",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 71,
                "name": "Tajikistan",
                "code": "TJ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 72,
                "name": "Palestinian Territory",
                "code": "PS",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 73,
                "name": "Oman",
                "code": "OM",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 74,
                "name": "Isle of Man",
                "code": "IM",
                "currency_id": 3,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 75,
                "name": "Croatia",
                "code": "HR",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 76,
                "name": "Sri Lanka",
                "code": "LK",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 77,
                "name": "Canada",
                "code": "CA",
                "currency_id": 2,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 78,
                "name": "Kenya",
                "code": "KE",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 79,
                "name": "Tonga",
                "code": "TO",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 80,
                "name": "French Southern Territories",
                "code": "TF",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 81,
                "name": "Dominican Republic",
                "code": "DO",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 82,
                "name": "Gibraltar",
                "code": "GI",
                "currency_id": 3,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 83,
                "name": "Northern Mariana Islands",
                "code": "MP",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 84,
                "name": "Azerbaijan",
                "code": "AZ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 85,
                "name": "Trinidad and Tobago",
                "code": "TT",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 86,
                "name": "Czech Republic",
                "code": "CZ",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 87,
                "name": "Latvia",
                "code": "LV",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 88,
                "name": "Malta",
                "code": "MT",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 89,
                "name": "Sweden",
                "code": "SE",
                "currency_id": 9,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 90,
                "name": "Belize",
                "code": "BZ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 91,
                "name": "Nicaragua",
                "code": "NI",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 92,
                "name": "Bouvet Island",
                "code": "BV",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 93,
                "name": "Peru",
                "code": "PE",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 94,
                "name": "Greece",
                "code": "GR",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 95,
                "name": "Chile",
                "code": "CL",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 96,
                "name": "United Arab Emirates",
                "code": "AE",
                "currency_id": 35,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 97,
                "name": "Aruba",
                "code": "AW",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 98,
                "name": "Vanuatu",
                "code": "VU",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 99,
                "name": "Indonesia",
                "code": "ID",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 100,
                "name": "Djibouti",
                "code": "DJ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 101,
                "name": "Saudi Arabia",
                "code": "SA",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 102,
                "name": "United States of America",
                "code": "US",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 103,
                "name": "Kazakhstan",
                "code": "KZ",
                "currency_id": 19,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 104,
                "name": "Sierra Leone",
                "code": "SL",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 105,
                "name": "Haiti",
                "code": "HT",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 106,
                "name": "Bulgaria",
                "code": "BG",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 107,
                "name": "Senegal",
                "code": "SN",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 108,
                "name": "Hungary",
                "code": "HU",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 109,
                "name": "Afghanistan",
                "code": "AF",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 110,
                "name": "Pitcairn",
                "code": "PN",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 111,
                "name": "Albania",
                "code": "AL",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 112,
                "name": "Montenegro",
                "code": "ME",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 113,
                "name": "Mauritius",
                "code": "MU",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 114,
                "name": "Uruguay",
                "code": "UY",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 115,
                "name": "Bahrain",
                "code": "BH",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 116,
                "name": "Colombia",
                "code": "CO",
                "currency_id": 23,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 117,
                "name": "Zimbabwe",
                "code": "ZW",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 118,
                "name": "Nepal",
                "code": "NP",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 119,
                "name": "Central African Republic",
                "code": "CF",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 120,
                "name": "Luxembourg",
                "code": "LU",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 121,
                "name": "Timor-Leste",
                "code": "TL",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 122,
                "name": "Algeria",
                "code": "DZ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 123,
                "name": "Bermuda",
                "code": "BM",
                "currency_id": 24,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 124,
                "name": "Turkey",
                "code": "TR",
                "currency_id": 11,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 125,
                "name": "Suriname",
                "code": "SR",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 126,
                "name": "Ghana",
                "code": "GH",
                "currency_id": 22,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 127,
                "name": "Saint Helena",
                "code": "SH",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 128,
                "name": "Namibia",
                "code": "NA",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 129,
                "name": "India",
                "code": "IN",
                "currency_id": 32,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 130,
                "name": "Guatemala",
                "code": "GT",
                "currency_id": 26,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 131,
                "name": "Portugal",
                "code": "PT",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 132,
                "name": "Palau",
                "code": "PW",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 133,
                "name": "Myanmar",
                "code": "MM",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 134,
                "name": "Jamaica",
                "code": "JM",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 135,
                "name": "Guinea-Bissau",
                "code": "GW",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 136,
                "name": "Sudan",
                "code": "SD",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 137,
                "name": "Holy See (Vatican City State]",
                "code": "VA",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 138,
                "name": "Cyprus",
                "code": "CY",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 139,
                "name": "Bolivia",
                "code": "BO",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 140,
                "name": "Eritrea",
                "code": "ER",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 141,
                "name": "Greenland",
                "code": "GL",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 142,
                "name": "Mongolia",
                "code": "MN",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 143,
                "name": "British Indian Ocean Territory",
                "code": "IO",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 144,
                "name": "Western Sahara",
                "code": "EH",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 145,
                "name": "Liberia",
                "code": "LR",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 146,
                "name": "Netherlands",
                "code": "NL",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 147,
                "name": "Faroe Islands",
                "code": "FO",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 148,
                "name": "Cameroon",
                "code": "CM",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 149,
                "name": "Burundi",
                "code": "BI",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 150,
                "name": "Papua New Guinea",
                "code": "PG",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 151,
                "name": "Finland",
                "code": "FI",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 152,
                "name": "Bhutan",
                "code": "BT",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 153,
                "name": "Honduras",
                "code": "HN",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 154,
                "name": "Kiribati",
                "code": "KI",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 155,
                "name": "Mauritania",
                "code": "MR",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 156,
                "name": "Guam",
                "code": "GU",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 157,
                "name": "Tokelau",
                "code": "TK",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 158,
                "name": "Solomon Islands",
                "code": "SB",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 159,
                "name": "Lesotho",
                "code": "LS",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 160,
                "name": "Guadeloupe",
                "code": "GP",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 161,
                "name": "Cocos (Keeling] Islands",
                "code": "CC",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 162,
                "name": "Cayman Islands",
                "code": "KY",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 163,
                "name": "Maldives",
                "code": "MV",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 164,
                "name": "Somalia",
                "code": "SO",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 165,
                "name": "Cape Verde",
                "code": "CV",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 166,
                "name": "Madagascar",
                "code": "MG",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 167,
                "name": "Iraq",
                "code": "IQ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 168,
                "name": "Anguilla",
                "code": "AI",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 169,
                "name": "Iceland",
                "code": "IS",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 170,
                "name": "Falkland Islands (Malvinas]",
                "code": "FK",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 171,
                "name": "Vietnam",
                "code": "VN",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 172,
                "name": "Ukraine",
                "code": "UA",
                "currency_id": 8,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 173,
                "name": "Paraguay",
                "code": "PY",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 174,
                "name": "Ireland",
                "code": "IE",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 175,
                "name": "Bosnia and Herzegovina",
                "code": "BA",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 176,
                "name": "Estonia",
                "code": "EE",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 177,
                "name": "Antarctica",
                "code": "AQ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 178,
                "name": "Ethiopia",
                "code": "ET",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 179,
                "name": "Pakistan",
                "code": "PK",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 180,
                "name": "Austria",
                "code": "AT",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 181,
                "name": "Samoa",
                "code": "WS",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 182,
                "name": "Tunisia",
                "code": "TN",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 183,
                "name": "Italy",
                "code": "IT",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 184,
                "name": "Jersey",
                "code": "JE",
                "currency_id": 3,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 185,
                "name": "French Guiana",
                "code": "GF",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 186,
                "name": "South Africa",
                "code": "ZA",
                "currency_id": 20,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 187,
                "name": "Burkina Faso",
                "code": "BF",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 188,
                "name": "Belgium",
                "code": "BE",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 189,
                "name": "Argentina",
                "code": "AR",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 190,
                "name": "Poland",
                "code": "PL",
                "currency_id": 12,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 191,
                "name": "Romania",
                "code": "RO",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 192,
                "name": "Cambodia",
                "code": "KH",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 193,
                "name": "Spain",
                "code": "ES",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 194,
                "name": "Philippines",
                "code": "PH",
                "currency_id": 25,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 195,
                "name": "American Samoa",
                "code": "AS",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 196,
                "name": "Aland Islands",
                "code": "AX",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 197,
                "name": "New Caledonia",
                "code": "NC",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 198,
                "name": "Tuvalu",
                "code": "TV",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 199,
                "name": "San Marino",
                "code": "SM",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 200,
                "name": "Botswana",
                "code": "BW",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 201,
                "name": "Ecuador",
                "code": "EC",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 202,
                "name": "Nauru",
                "code": "NR",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 203,
                "name": "Saint Kitts and Nevis",
                "code": "KN",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 204,
                "name": "Mexico",
                "code": "MX",
                "currency_id": 18,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 205,
                "name": "Mayotte",
                "code": "YT",
                "currency_id": 4,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 206,
                "name": "Grenada",
                "code": "GD",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 207,
                "name": "Antigua and Barbuda",
                "code": "AG",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 208,
                "name": "New Zealand",
                "code": "NZ",
                "currency_id": 21,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 209,
                "name": "Morocco",
                "code": "MA",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 210,
                "name": "Comoros",
                "code": "KM",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 211,
                "name": "Rwanda",
                "code": "RW",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 212,
                "name": "Benin",
                "code": "BJ",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 213,
                "name": "Armenia",
                "code": "AM",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 214,
                "name": "Mali",
                "code": "ML",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 215,
                "name": "Jordan",
                "code": "JO",
                "currency_id": 1,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 216,
                "name": "Costa Rica",
                "code": "CR",
                "currency_id": 17,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 217,
                "name": "Singapore",
                "code": "SG",
                "currency_id": 16,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 218,
                "name": "Hong Kong",
                "code": "HK",
                "currency_id": 27,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            },
            {
                "id": 219,
                "name": "Taiwan",
                "code": "TW",
                "currency_id": 28,
                "created_at": "2020-08-24T15:53:07.000000Z",
                "updated_at": "2020-08-24T15:53:07.000000Z"
            }
        ],
        "count": 219
    }`)
